import { render } from "./AdminEventRegistrations.vue?vue&type=template&id=51356fc0&scoped=true&ts=true"
import script from "./AdminEventRegistrations.vue?vue&type=script&lang=ts"
export * from "./AdminEventRegistrations.vue?vue&type=script&lang=ts"

import "./AdminEventRegistrations.vue?vue&type=style&index=0&id=51356fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51356fc0"]])

export default __exports__